var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CompactVideoCarousel } from './Compact';
import { CompactViewProvider } from './Providers/CompactViewProvider';
import { FullWidthVideoCarousel } from './FullWidth';
export const VideoCarousel = (_a) => {
    var { compact } = _a, props = __rest(_a, ["compact"]);
    return (React.createElement(CompactViewProvider, { alwaysCompact: compact }, compact ? (React.createElement(CompactVideoCarousel, Object.assign({}, props))) : (React.createElement(FullWidthVideoCarousel, Object.assign({}, props)))));
};
//# sourceMappingURL=index.js.map